import { YEAR_FLAGS } from '../time'
import { createEnum } from '../helpers'

export const COST_OF_GOODS_IMPORT_ERRORS = ['zodSchemaError'] as const

export const COST_OF_GOODS_IMPORT_ERROR_TYPES = createEnum(COST_OF_GOODS_IMPORT_ERRORS)
export type CostOfGoodsImportErrorType = (typeof COST_OF_GOODS_IMPORT_ERRORS)[number]

export const COST_OF_GOODS_CREATE_ERRORS = ['crtPeriodConflict'] as const

export const COST_OF_GOODS_CREATE_ERROR_TYPES = createEnum(COST_OF_GOODS_CREATE_ERRORS)
export type CostOfGoodsCreateErrorType = (typeof COST_OF_GOODS_CREATE_ERRORS)[number]

export const COST_OF_GOODS_CREATE_CONSTRAINT_TO_ERROR: Record<string, CostOfGoodsCreateErrorType> =
  {
    cost_of_goods_crt_period_unique: COST_OF_GOODS_CREATE_ERROR_TYPES.crtPeriodConflict,
  }

export const COST_OF_GOODS_CATEGORIES = [
  'Leaf',
  'Wrapping',
  'L&OH',
  'Mark-up',
  'Customs',
  'Freight',
  'Primary',
  'External',
  'Other Cos',
] as const

export type CostOfGoodsCategory = (typeof COST_OF_GOODS_CATEGORIES)[number]

// Intentionally a separate const from YEAR_FLAG_VALUES: this drives
// COST_OF_GOODS_CATEGORIES_WITH_YEAR_SUFFIX / COST_OF_GOODS_PIVOTED_COLUMNS, so adding a new CRT year code
// must not silently expand those column sets. It reuses the CRT literals as its source without coupling
// cardinality.
export const COST_OF_GOODS_YEAR_SUFFIXES = [YEAR_FLAGS.CY, YEAR_FLAGS.NY] as const
export type CostOfGoodsYearSuffix = (typeof COST_OF_GOODS_YEAR_SUFFIXES)[number]

export const COST_OF_GOODS_CATEGORIES_WITH_YEAR_SUFFIX = COST_OF_GOODS_YEAR_SUFFIXES.flatMap(
  (year) => COST_OF_GOODS_CATEGORIES.map((base) => `${base} ${year}` as const),
)

export const COST_OF_GOODS_CATEGORY_WITH_YEAR_SUFFIX_VALUES = createEnum(
  COST_OF_GOODS_CATEGORIES_WITH_YEAR_SUFFIX,
)
export type CostOfGoodsCategoryWithYearSuffix =
  (typeof COST_OF_GOODS_CATEGORIES_WITH_YEAR_SUFFIX)[number]

export function getCostOfGoodsBaseCategory(category: string): CostOfGoodsCategory {
  return category.replace(/ (CY|NY)$/, '') as CostOfGoodsCategory
}

export const COST_OF_GOODS_MONTHS = {
  jan: 1,
  feb: 2,
  mar: 3,
  apr: 4,
  may: 5,
  jun: 6,
  jul: 7,
  aug: 8,
  sep: 9,
  oct: 10,
  nov: 11,
  dec: 12,
} as const
export type CostOfGoodMonthName = keyof typeof COST_OF_GOODS_MONTHS
type CostOfGoodMonthIndex = (typeof COST_OF_GOODS_MONTHS)[CostOfGoodMonthName]
export type CostOfGoodsColumnKeys = `${CostOfGoodsCategoryWithYearSuffix} ${CostOfGoodMonthIndex}`

export const COST_OF_GOODS_PIVOTED_COLUMNS: CostOfGoodsColumnKeys[] =
  COST_OF_GOODS_CATEGORIES_WITH_YEAR_SUFFIX.flatMap((categoryWithYear) =>
    Object.values(COST_OF_GOODS_MONTHS).map(
      (month) => `${categoryWithYear} ${month}` as CostOfGoodsColumnKeys,
    ),
  )
